const initialState = {
  loggedInUser: null,
  account: null,
  jwt: null,
  profiles: null,
  defaultHeaders: {},
  visibleConversations: null,
  conversationFilter: null,
  screenSize: 'md',
  isSupport: null,
  apiUrl: null,
  dateFormat: 'DD/MM/YYYY',
  features: {},
  myConversationIds: [],
  myTeamIds: [],
  connected: true,
  activityPayload: {},
};

const reductions = {
  SET_LOGGED_IN_USER: function (state, action) {
    return Object.assign({}, state, { loggedInUser: action.payload });
  },
  DELETE_LOGGED_IN_USER: function (state, action) {
    return Object.assign({}, state, { loggedInUser: action.payload });
  },
  SET_ACCOUNT: function (state, action) {
    return Object.assign({}, state, { account: action.payload });
  },
  SET_JWT: function (state, action) {
    return Object.assign({}, state, { jwt: action.payload });
  },
  DELETE_JWT: function (state, action) {
    return Object.assign({}, state, { jwt: action.payload });
  },
  SET_IS_SUPPORT: function (state, action) {
    return Object.assign({}, state, { isSupport: action.payload });
  },
  SET_API_URL: function (state, action) {
    return Object.assign({}, state, { apiUrl: action.payload });
  },
  SET_DATE_FORMAT: function (state, action) {
    return Object.assign({}, state, { dateFormat: action.payload });
  },
  SET_PROFILES: function (state, action) {
    return Object.assign({}, state, { profiles: action.payload });
  },
  SET_FEATURES: function (state, action) {
    return Object.assign({}, state, { features: action.payload });
  },
  UPDATE_FEATURE: function (state, action) {
    if (action.payload.features) {
      return { ...state, features: action.payload.features };
    }
    return state;
  },
  SET_DEFAULT_HEADERS: function (state, action) {
    return Object.assign({}, state, { defaultHeaders: action.payload });
  },
  DELETE_DEFAULT_HEADERS: function (state, action) {
    return Object.assign({}, state, { defaultHeaders: action.payload });
  },
  SET_CONVERSATION_FILTER: function (state, action) {
    return Object.assign({}, state, { conversationFilter: action.payload });
  },
  CLEAR_LOGIN: function (state, action) {
    return Object.assign({}, state, {
      jwt: null,
      loggedInUser: null,
      defaultHeaders: null,
    });
  },
  SET_SCREEN_SIZE: function (state, action) {
    return Object.assign({}, state, { screenSize: action.payload });
  },
  UPDATE_AGENT: function (state, action) {
    if (state.loggedInUser && action.payload.id === state.loggedInUser.id) {
      return Object.assign({}, state, { loggedInUser: action.payload });
    }
    return state;
  },
  NEW_AGENTS: function (state, action) {
    if (state.loggedInUser) {
      const user = action.payload.find((a) => a.id === state.loggedInUser.id);
      if (user) {
        return Object.assign({}, state, { loggedInUser: user });
      }
    }
    return state;
  },

  // Keep myConversationIds up to date
  NEW_AGENT_CONVERSATION: function (state, action) {
    if (
      state.loggedInUser &&
      action.payload.agent_id === state.loggedInUser.id
    ) {
      return Object.assign({}, state, {
        myConversationIds: state.myConversationIds.concat(
          action.payload.conversation_id
        ),
      });
    }
    return state;
  },
  NEW_AGENT_CONVERSATIONS: function (state, action) {
    if (state.loggedInUser) {
      const convoIds = action.payload
        .filter((agentConvo) => agentConvo.agent_id === state.loggedInUser.id)
        .map((agentConvo) => agentConvo.conversation_id);
      return Object.assign({}, state, {
        myConversationIds: state.myConversationIds.concat(convoIds),
      });
    }
    return state;
  },
  DELETE_AGENT_CONVERSATION: function (state, action) {
    if (
      state.loggedInUser &&
      action.payload.agent_id === state.loggedInUser.id
    ) {
      // Because the conversation could be in there multiple times due to different AgentTeam relations we only want to remove the first instance
      const convoIds = [];
      let alreadyRemoved = false;
      for (let index = 0; index < state.myConversationIds.length; index++) {
        const convoId = state.myConversationIds[index];
        if (alreadyRemoved || convoId !== action.payload.conversation_id) {
          convoIds.push(convoId);
        } else {
          alreadyRemoved = true;
        }
      }
      return Object.assign({}, state, { myConversationIds: convoIds });
    }
    return state;
  },
  NEW_CONVERSATION_TEAM: function (state, action) {
    if (state.myTeamIds.includes(action.payload.team_id)) {
      return Object.assign({}, state, {
        myConversationIds: state.myConversationIds.concat(
          action.payload.conversation_id
        ),
      });
    }
    return state;
  },
  NEW_CONVERSATION_TEAMS: function (state, action) {
    const convoIds = action.payload
      .filter((convoTeam) => state.myTeamIds.includes(convoTeam.team_id))
      .map((convoTeam) => convoTeam.conversation_id);
    return Object.assign({}, state, {
      myConversationIds: state.myConversationIds.concat(convoIds),
    });
  },
  DELETE_CONVERSATION_TEAM: function (state, action) {
    if (state.myTeamIds.includes(action.payload.team_id)) {
      // Because the conversation could be in there multiple times due to different AgentTeam relations we only want to remove the first instance
      const convoIds = [];
      let alreadyRemoved = false;
      for (let index = 0; index < state.myConversationIds.length; index++) {
        const convoId = state.myConversationIds[index];
        if (alreadyRemoved || convoId !== action.payload.conversation_id) {
          convoIds.push(convoId);
        } else {
          alreadyRemoved = true;
        }
      }
      return Object.assign({}, state, { myConversationIds: convoIds });
    }
    return state;
  },

  // Keep myTeamIds up to date
  NEW_AGENT_TEAM: function (state, action) {
    if (
      state.loggedInUser &&
      action.payload.agent_id === state.loggedInUser.id
    ) {
      return Object.assign({}, state, {
        myTeamIds: state.myTeamIds.concat(action.payload.team_id),
      });
    }
    return state;
  },
  NEW_AGENT_TEAMS: function (state, action) {
    if (state.loggedInUser) {
      const teamIds = action.payload
        .filter((agentTeam) => agentTeam.agent_id === state.loggedInUser.id)
        .map((agentTeam) => agentTeam.team_id);
      return Object.assign({}, state, {
        myTeamIds: state.myTeamIds.concat(teamIds),
      });
    }
    return state;
  },
  DELETE_AGENT_TEAM: function (state, action) {
    if (
      state.loggedInUser &&
      action.payload.agent_id === state.loggedInUser.id
    ) {
      const teamIds = state.myTeamIds.filter(
        (teamId) => teamId !== action.payload.team_id
      );
      return Object.assign({}, state, {
        myTeamIds: state.myTeamIds.concat(teamIds),
      });
    }
    return state;
  },

  USER_WAS_DISCONNECTED: (state) => {
    return Object.assign({}, state, { connected: false });
  },

  USER_WAS_CONNECTED: (state) => {
    return Object.assign({}, state, { connected: true });
  },

  NEW_AVAILABILITY_ACTIVITY: (state, action) => {
    return Object.assign({}, state, {
      activityPayload: action.payload,
    });
  },

  AVAILABILITY_ACTIVITY_READ: (state) => {
    return Object.assign({}, state, {
      activityPayload: {},
    });
  },
};

const appStateReducer = (state = initialState, action) => {
  if (action && action.type && reductions[action.type]) {
    return reductions[action.type](state, action);
  }
  return state;
};

export default appStateReducer;
